/**
 * Returns an array of key-value pairs from an object.
 * Alias for Object.entries providing a more functional API.
 *
 * @param obj - Object to extract entries from
 * @returns Array of [key, value] tuples
 *
 * @example
 * ```ts
 * import { Items } from "@pdfking/tfunc"
 *
 * const obj = { name: "John", age: 30 }
 * const entries = Items(obj)
 * // [["name", "John"], ["age", 30]]
 *
 * for (const [key, value] of Items(obj)) {
 *   console.log(`${key}: ${value}`)
 * }
 * ```
 */
export const Items = Object.entries
